import type { ComponentType } from "react";
import { useSquareShape } from "@/lib/use-square-shape";

/** Wrap a route component so the page (and its popups) use square corners. */
export function withSquareShape<P extends object>(C: ComponentType<P>) {
  return function Squared(props: P) {
    useSquareShape();
    return <C {...props} />;
  };
}
